import { Flex, Select, Text } from '@chakra-ui/react'
import React from 'react'

import { useAudioSettingsStyles } from './componentStyles/AudioSettings.style'

interface AudioSettingsProps {
  inputs: MediaDeviceInfo[]
  selectedInput: string
  onInputDeviceChange: (deviceId: string) => void
  outputs: MediaDeviceInfo[]
  selectedOutput: string
  onOutputDeviceChange: (deviceId: string) => void
}
export const AudioSettings = ({
  inputs,
  selectedInput,
  onInputDeviceChange,
  outputs,
  selectedOutput,
  onOutputDeviceChange,
}: AudioSettingsProps) => {
  const handleOutputSelectChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    onOutputDeviceChange(e.target.value)
  }
  const handleInputSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onInputDeviceChange(e.target.value)
  }

  const style = useAudioSettingsStyles()

  return (
    <Flex direction="column" __css={style.container}>
      {outputs.length > 0 && (
        <Flex sx={style.dropdownContainer}>
          <Text sx={style.text}>Output Source - Speakers</Text>
          <Select
            variant="outline"
            onChange={handleOutputSelectChange}
            value={selectedOutput}
            sx={style.select}
          >
            {outputs.map((outputDevice) => {
              return (
                <option
                  key={outputDevice.deviceId}
                  value={outputDevice.deviceId}
                >
                  {outputDevice.label}
                </option>
              )
            })}
          </Select>
        </Flex>
      )}
      {inputs.length > 0 && (
        <Flex sx={style.dropdownContainer}>
          <Text sx={style.text}>Input Source - Microphone</Text>
          <Select
            variant="outline"
            onChange={handleInputSelectChange}
            value={selectedInput}
            sx={style.select}
          >
            {inputs.map((inputDevice) => {
              return (
                <option key={inputDevice.deviceId} value={inputDevice.deviceId}>
                  {inputDevice.label}
                </option>
              )
            })}
          </Select>
        </Flex>
      )}
    </Flex>
  )
}
